module.exports = __webpack_public_path__ + "img/hotel-27a.17ed05ab.jpeg";